/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import { GenericCardHeaderProps } from './types';
import './styles.scss';
import { generateID } from '../../base/helper';

/**
 * UI Toolkit Generic Card Header component
 * @public
 */
const Header: React.FC<GenericCardHeaderProps> = ({
  title,
  tooltip,
  end,
  borderBottom = true,
  id = generateID('clientos-ui-toolkit-generic-card-header')
}) => {
  // Define a base class name
  const baseClassName = 'clientos-ui-toolkit-generic-card__content__header';

  // Conditionally add 'with-border' class
  const className = `${baseClassName} ${borderBottom ? 'with-border' : ''}`;

  return (
    <div
      className={className}
      id={id}
    >
      <div
        className="clientos-ui-toolkit-generic-card__content__header__start"
        id={`${id}__start`}
      >
        <h2
          className="clientos-ui-toolkit-generic-card__content__header__title title-small--medium"
          tabIndex={-1}
          id={`${id}__title`}
          aria-label={title}
          role="text"
        >
          {title}
        </h2>
        {tooltip && (
          <div
            className="clientos-ui-toolkit-generic-card__content__header__tooltip"
            id={`${id}__tooltip`}
          >
            {tooltip}
          </div>
        )}
      </div>
      {end && (
        <div
          className="clientos-ui-toolkit-generic-card__content__header__end"
          id={`${id}__end`}
        >
          {end}
        </div>
      )}
    </div>
  );
};
export default memo(Header);
